export const APP_LOGO_HEIGHT = 40;
export const APP_LOGO_WIDTH = 96;
